<template lang="html">

<div v-bind:class="{'slds-is-open': opened}" class="slds-section">
  <h3 class="slds-section__title">
    <button v-on:click="$emit('click')" aria-controls="expando-unique-id" aria-expanded="true" class="slds-button slds-section__title-action">
      <svg class="slds-section__title-action-icon slds-button__icon slds-button__icon_left" aria-hidden="true">
        <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#switch"></use>
      </svg>
      <span class="slds-truncate" v-bind:title="title">{{title}}</span>

  <div class="slds-page-header__controls" style="position: relative; left:50%;">

    <div v-for="action in actions" v-bind:key="action.name" class="slds-page-header__control" >

      <button v-on:click.prevent.stop="$emit('change',action.name)" v-bind:id="action.id"
        v-bind:class="action.class?action.class:'slds-button_neutral'"
      class="slds-button slds-button_stateful slds-not-selected pippo" aria-live="assertive">
        <span class="slds-text-not-selected">
          <svg v-if="action.symbol" class="slds-button__icon slds-button__icon_small slds-button__icon_left" aria-hidden="true">
            <use v-bind:xlink:href="'/assets/icons/utility-sprite/svg/symbols.svg#'+action.symbol"></use>
          </svg>
          {{action.title}}
        </span>
      </button>

    </div>

  </div>
      </button>


  </h3>

  <div aria-hidden="false" class="slds-section__content" id="expando-unique-id">
    <slot></slot>
  </div>

</div>

</template>

<script>

export default {
  name: 'gnetExpandable',
  components: {
  },
  computed: {
  },
  props: {
    title: String,
    opened: Boolean,
    actions: Array
  },
  data: function () {
      return {
    }
  },
  mounted: function() {
  },
  async created() {

  },
  methods: {
  }
}
</script>

<style scoped>
</style>
